import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';

export default function PreguntaTexto({
  textoPregunta,
  fraseSugerencia,
  numeroPregunta,
  onChangeRespuesta,
  esObligatoria,
  defaultValue = ''
}) {
  const [texto, setTexto] = useState(String(defaultValue || ''));

  // Actualiza si defaultValue cambia
  useEffect(() => {
    const nuevoValor = String(defaultValue || '');
    if (nuevoValor !== texto) {
      setTexto(nuevoValor);
    }
  }, [defaultValue]);

  const handleTextoChange = (event) => {
    setTexto(event.target.value);
  };

  useEffect(() => {
    const respuesta = {
      numeroPregunta,
      tieneContenido: texto.trim() !== '',
      contenido: [numeroPregunta, texto],
      esObligatoria
    };
    onChangeRespuesta(respuesta);
  }, [texto]);

  return (
    <div>
      {textoPregunta}
      <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '330px' } }} noValidate autoComplete="off">
        <TextField
          label={fraseSugerencia}
          id="standard-basic"
          variant="outlined"
          value={texto}
          onChange={handleTextoChange}
          sx={{ width: '330px', height: '40px' }}
          InputProps={{ sx: { height: '40px' } }}
        />
      </Box>
      <div>
        <br />
      </div>
    </div>
  );
}
